<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Getting the Most Out of <i>Prayer and Listening</i></a></div>
<div class="table" id="tableau-001">
<div class="table-align">
<table border="" style="border-collapse:collapse; border-spacing:0px;">
<colgroup style="padding:7px;">
<col style="width:15%;padding:7px;"/>
<col style="width:85%;padding:7px;"/>
</colgroup>
<tbody>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample"><span class="mev2">ONE</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample">Conversation with God<br/><span class="mev5">G<span class="small">ENESIS</span> 15:1-16; 17:15-22; 18:1-15</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev2">TWO</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">Praying with Authenticity<br/><span class="mev5">P<span class="small">SALM</span> 74:1-23</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev2">THREE</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">The Prayer of Request<br/><span class="mev5">M<span class="small">ATTHEW</span> 6:9-13</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev2">FOUR</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">Listening to God in Prayer<br/><span class="mev5">1 C<span class="small">HRONICLES</span> 14:8-17</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev2">FIVE</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">Praying for Others as Jesus Did<br/><span class="mev5">L<span class="small">UKE</span> 22:31-34</span></span></p></td>
</tr>
<tr style="padding:7px;">
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev2">SIX</span></span></p></td>
<td style="padding:7px;vertical-align:top;"><p class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">Practicing God’s Presence<br/><span class="mev5">1 T<span class="small">HESSALONIANS</span> 5:16-18</span></span></p></td>
</tr>
</tbody></table></div></div>
<div class="SOM_appen"><span href="#/chap7" title="Link target outside of Sample">Leader’s Notes</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">What Should we Study Next?</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?0d33ba9c